import { lazy } from 'react';
import { PublicRoutes } from '@enums/publicRouteEnums';
import { PublicRoutesTitles } from '@enums/publicRoutesTitles';

const SessionLogin = lazy(() => import('@components/login/SessionLogin'));
const Login = lazy(() => import('@components/login/Login'));
const TwoFactorAuth = lazy(() => import('@components/login/TwoFactorAuth'));
const ForgotPassword = lazy(() => import('@components/login/ForgotPassword'));
const ResetPassword = lazy(() => import('@components/login/ResetPassword'));
const ServiceMaintenance = lazy(() => import('@components/ServiceMaintenance'));

export const publicRoutes = [
  {
    title: PublicRoutesTitles.SESSION_LOGIN,
    path: PublicRoutes.DEFAULT,
    component: SessionLogin,
  },
  {
    title: PublicRoutesTitles.LOGIN,
    path: PublicRoutes.LOGIN,
    component: Login,
  },
  {
    title: PublicRoutesTitles.TWO_FACTOR,
    path: PublicRoutes.TWO_FACTOR,
    component: TwoFactorAuth,
  },
  {
    title: PublicRoutesTitles.FORGOT_PASSWORD,
    path: PublicRoutes.FORGOT_PASSWORD,
    component: ForgotPassword,
  },
  {
    title: PublicRoutesTitles.RESET_PASSWORD,
    path: PublicRoutes.RESET_PASSWORD,
    component: ResetPassword,
  },
  {
    title: PublicRoutesTitles.SERVICE_MAINTENANCE,
    path: PublicRoutes.SERVICE_MAINTENANCE,
    component: ServiceMaintenance,
  },
];
